import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';

interface BkLoaderProps {
  open: boolean;
  loaderTitle: string;
}

const BkLoader: React.FC<BkLoaderProps> = ({ open, loaderTitle }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25rem',
        zIndex: '9999',
      }}
    >
      <CircularProgress sx={{ color: '#FFF' }} size={50} />
      <Typography sx={{ marginTop: '0.9375rem', fontSize: '1.25rem', color: '#FFF' }}>
        {loaderTitle}
      </Typography>
    </Backdrop>
  );
};

export default BkLoader;
